var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4678 11.4387L11.001 7.96392H7.6669V5.70905C7.6669 4.75842 8.13265 3.8318 9.6259 3.8318H11.1416V0.873422C11.1416 0.873422 9.76615 0.638672 8.45102 0.638672C5.70527 0.638672 3.91052 2.30292 3.91052 5.31567V7.96392H0.858398V11.4387H3.91052V19.8387H7.6669V11.4387H10.4678Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.8d282bbd17b1508c545c1ba851bbd1b0.svg";
export { ForwardRef as ReactComponent };